const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MATERIALS)
export const apiMaterials = {
	fetchMaterials: async (
		tags: string[] | undefined,
		diets: string[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	) => {
		const { data, meta } = await apiCommon<IDietMaterial[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { tags, diets, name: search }),
		})
		return { data: data.map(d => Material(d)), meta }
	},
	fetchMaterialById: async (id: string | number): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietMaterial>(`${groupPrefix}/${id}`, { method: 'GET' })

		return Material(data)
	},
	createDietMaterial: async (payload: IDietMaterialCreatePayload): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietMaterial>(`${groupPrefix}`, { method: 'POST', body: payload })

		return Material(data)
	},
	updateDietMaterial: async (payload: IDietMaterialUpdatePayload): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietMaterial>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return Material(data)
	},
	duplicateDietMaterial: async (id: number): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietMaterial>(`${groupPrefix}/${id}/duplicate`, { method: 'POST' })

		return Material(data)
	},
	deleteDietMaterial: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
	fetchDietMaterialEditHistory: async (id: number, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IDietMaterialHistory[]>(`${groupPrefix}/${id}/logs`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})

		return { data: data.map(d => DietMaterialEditHistory(d)), meta }
	},
}
